import SocialLinksForm from './social-links-form'

export default SocialLinksForm;